module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result27-3d7b80a57951301f2daebb1abe103d50.png";